import { Modal, Table, Button } from "antd";
import { useEffect, useState } from "react";
import service from "../../../@services";
import * as Utils from '../../../@utils'
const taskTypeMap = {
  "1":"商品批量上传并创建",
  "2":"门店商品批量导入改价",
  "3":"批量设置销售库存",
  "9":"门店商品档案"
}
const statusMap = {
  "0": "待解析",
  "1": "解析中",
  "2": "解析失败",
  "3": "待处理",
  "4": "处理中",
  '5': "已完成",
  "6": "数据异常（业务数据错误或没有明细数据）"
}
// eslint-disable-next-line import/no-anonymous-default-export
export default props => {
  const {visible,close,type=[]} = props
  const [tableData, setTableData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
  useEffect(()=>{
    setTableData([])
    if(visible){
      fetchData({taskTypeList:type, pageIndex: 1, pageSize: 10})
    }
  },[visible])

  const handleTableChange = (pagination) => {
    setPagination(pagination)
    const params = Object.assign({},{ taskTypeList:type, pageIndex: pagination.current, pageSize: pagination.pageSize})
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    const data = await service.common.getFileTaskByCondition(params)
    setLoading(false)
    if(data){
      setTableData(data.result)
      setPagination({
        current: data.pageIndex,
        pageSize: data.pageSize,
        total: data.recordCount
      })
    }
  }
  const downloadList = (record) => {
    service.common.downloadFileById(record.id).then((res)=>{
      Utils.download(res, taskTypeMap[record.taskType]+'记录.xlsx')
    })

  }
  const columns = [
    { title: '导入类型', dataIndex: 'taskType', key: 'taskType', render: (taskType)=> (
        taskTypeMap[taskType]
      )
    },
    { title: '状态', dataIndex: 'status', key: 'status', render: (status)=> (
        statusMap[status]
      )
    },
    { title: '数据条数', dataIndex: 'fileContentCount', key: 'fileContentCount' },
    { title: '导入时间', dataIndex: 'operTime', key: 'operTime' },
    { title: '操作人员', dataIndex: 'operName', key: 'operName' },
    {
      title: '操作',
      dataIndex: '',
      key: 'x',
      render: (text,record,index) => (
          record.downDealFileFlag===2
          ?<Button type="link" onClick={()=>downloadList(record)}>下载</Button>
          :
          record.downDealFileFlag===3
          ?
          "文件处理失败"
          :
          record.downDealFileFlag===1
          ?
          "文件待处理"
          :
          "文件处理中……"
      ),
    },
  ]
  return (
    <Modal
      visible={visible}
      width="60%"
      title="导入记录"
      onCancel={close}
      footer={[
        <Button key="back" onClick={close}>关闭</Button>,
      ]}
    >
      <Table
        rowKey={record=>record.id}
        dataSource={tableData}
        columns={columns}
        loading={loading}
        pagination={pagination}
        onChange={handleTableChange}
      />
    </Modal>
  );
}
